import gql from 'graphql-tag'
import { storySpotlightFragment } from '@components/story-spotlight/story-spotlight.fragment'

export const MEMBER_FEATURED_STORIES_QUERY = gql`
query MemberEventsLandingPage($preview: Boolean) {
  memberEventsLandingCollection(limit: 1, preview: $preview) {
    items {
      featuredStoriesHeadline
      featuredStoriesCtaText
      featuredStoriesCtaLink
      featuredStoriesCollection(limit: 5) {
        total
        items {
         ${storySpotlightFragment}
        }
      }
    }
  }
}
`
